import React from 'react';
import PropTypes from 'prop-types';
import FatalError from '../components/FatalError';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error.message };
  }

  render() {
    const { hasError, error } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <div style={{ height: '100vh' }}>
          <FatalError error={error} />
        </div>
      );
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.object,
};
ErrorBoundary.defaultProps = {
  children: {},
};
